// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"7e71affd3fbf262706b0","691":"7f093ee84d758608e0e3"}[chunkId] + ".js";
};